import {
    formatPermissions,
    can as helpCan,
} from '../../../services/auth/permissions'

/**
 * @description
 * Check if has branch office
 *
 * @param      {object}   state    The state
 * @param      {object}   getters  The getters
 * @return     {boolean}  true has branch office, false hasn't branch office
 */
const hasBrachOffice = (state, getters) => getters.hasEmployee && state.user.hr_employee.g_branch_office != null

/**
 * @description
 * Check if has employee
 *
 * @param      {object}   state    The state
 * @param      {object}   getters  The getters
 * @return     {boolean}  true has employee, false hasn't employee
 */
const hasEmployee = (state, getters) => getters.hasUser && state.user.hr_employee != null

/**
 * @description
 * Check if has user
 *
 * @param      {object}   state   The state
 * @return     {boolean}  true has user, false hasn't user
 */
const hasUser = state => state.user != null

/**
 * @description
 * Check if user is authenticated with state data (from local storage)
 *
 * @param {@object} state with state data of auth module
 * @return {boolean} true is authenticated, false otherwise
 */
const isAuthenticated = state => !!state.token

/**
 * @description
 * Get status of user (success, error or loading)
 *
 * @param {object} state with state data of auth module
 * @return {string}
 */
const authStatus = state => state.status

const can = state => helpCan(formatPermissions(state.permissions))

/**
 * @description
 * Get data of user employee
 *
 * @param      {object}  state    The state
 * @param      {object}  getters  The getters
 * @return     {<object} user hr_employee data
 */
const userEmployee = ( state, getters ) => getters.hasEmployee ? state.user.hr_employee: {}

/**
 * @description
 * Get data of user employee branch office
 *
 * @param      {object}  state    The state
 * @param      {object}  getters  The getters
 * @return     {<object} g_user hr_employee g_branch_office data
 */
const userEmployeeBranchOffice = ( state, getters ) => getters.hasBrachOffice ? state.user.hr_employee.g_branch_office : {}

/**
 * @description
 * Get data of user employee branch office id
 *
 * @param      {object}  state    The state
 * @param      {object}  getters  The getters
 * @return     {<object} g_user hr_employee g_branch_office_id
 */
const userEmployeeBranchOfficeId = ( state, getters ) => getters.hasEmployee ? state.user.hr_employee.g_branch_office_id : null

//
export default {
	hasBrachOffice,
	hasEmployee,
	hasUser,
    isAuthenticated,
    authStatus,
    can,
    userEmployee,
    userEmployeeBranchOffice,
    userEmployeeBranchOfficeId,
}
